module.exports = __webpack_public_path__ + "static/map-5553672757d5d5c1ec6fba810734f496.png";